'use client';
import React from 'react'
import { Accordion } from 'flowbite-react';

const AccordionComponent = () => {
    return (
        <>
            <Accordion>
                <Accordion.Panel>
                    <Accordion.Title>
                    What is TheFinMaster.com?
                    </Accordion.Title>
                    <Accordion.Content>
                        <p className="mb-2 text-gray-500 dark:text-gray-400">
                        TheFinMaster.com is your one-stop shop for all things personal finance! We provide clear and unbiased information on a wide range of financial products and services, like credit cards, mutual funds, and insurance. Think of us as your friendly neighborhood financial guide, helping you navigate the complexities of the financial world and make informed decisions. </p>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title>
                    Can I compare financial products side-by-side on TheFinMaster.com?
                    </Accordion.Title>
                    <Accordion.Content>
                        <p className="mb-2 text-gray-500 dark:text-gray-400">
                        Absolutely! We understand the importance of comparing different options before making a financial decision. TheFinMaster.com offers user-friendly comparison tools for credit cards, mutual funds, and insurance policies.  These tools allow you to analyze key features, fees, and benefits to choose the product that best aligns with your needs. </p>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title>
                    Does TheFinMaster.com offer any educational resources?
                    </Accordion.Title>
                    <Accordion.Content>
                        <p className="mb-2 text-gray-500 dark:text-gray-400">
                        TheFinMaster.com offers a comprehensive library of educational resources, including informative blog posts. Our engaging blog articles cover a wide range of financial topics, from the basics of budgeting and saving to more complex concepts like investing and retirement planning. </p>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title>
                    Is TheFinMaster.com affiliated with any financial institutions?
                    </Accordion.Title>
                    <Accordion.Content>
                        <p className="mb-2 text-gray-500 dark:text-gray-400">
                        TheFinMaster.com maintains a strict policy of editorial independence. We are not affiliated with any banks, investment companies, or insurance providers. This ensures that the information and recommendations we provide are objective and unbiased.  Our goal is to empower you with the knowledge to make informed financial decisions, not to promote specific products or service.</p>
                    </Accordion.Content>
                </Accordion.Panel>
                 <Accordion.Panel>
                    <Accordion.Title>
                    Is FinMaster a financial advisor or a product seller?
                    </Accordion.Title>
                    <Accordion.Content>
                        <p className="mb-2 text-gray-500 dark:text-gray-400">
                        No, FinMaster is neither a financial advisor nor a seller. We are an independent platform that provides unbiased information, comparisons, and tools to help you make informed financial decisions.​                        </p>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title>
                    Which financial products can I compare on FinMaster?
                    </Accordion.Title>
                    <Accordion.Content>
                        <p className="mb-2 text-gray-500 dark:text-gray-400">
                        You can compare a wide range of financial products, including credit cards, loans, insurance policies and mutual funds, all in one place.​
                        </p>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title>
                    How does FinMaster ensure the information is up-to-date?
                    </Accordion.Title>
                    <Accordion.Content>
                        <p className="mb-2 text-gray-500 dark:text-gray-400">
                        We regularly update our database by sourcing information from official bank and financial institution websites, ensuring you have access to the latest data.​
                        </p>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title>
                    Do I need to create an account to use FinMaster's tools?
                    </Accordion.Title>
                    <Accordion.Content>
                        <p className="mb-2 text-gray-500 dark:text-gray-400">
                        No account creation is required. All our comparison tools and calculators are freely accessible without any sign-up.​                        </p>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title>
                    Is there a cost to use FinMaster's services?
                    </Accordion.Title>
                    <Accordion.Content>
                        <p className="mb-2 text-gray-500 dark:text-gray-400">
                        FinMaster is completely free to use. We aim to provide accessible financial information without any charges.​
                        </p>
                    </Accordion.Content>
                </Accordion.Panel>
                {/* <Accordion.Panel>
                    <Accordion.Title>
                        Can I trust the information provided on FinancialEase Hub?
                    </Accordion.Title>
                    <Accordion.Content>
                        <p className="mb-2 text-gray-500 dark:text-gray-400">
                            Absolutely. We are committed to providing accurate and reliable information. Our comparisons are based on thorough research and analysis, and we strive to maintain the highest standards of integrity and transparency.
                        </p>
                    </Accordion.Content>
                </Accordion.Panel>  */}
            </Accordion>
        </>
    )
}

export default AccordionComponent
